<template>
  <div>
    <!-- 找资料页面 -->
    <!-- 轮播图 start-->
    <div class="data-rotation">
      <el-carousel height="300px">
        <el-carousel-item v-for="(item, index) in rotationList" :key="index">
          <a :href="item.targetAddress" target="blank">
            <el-image
              style="width: 100%; height: 300px"
              :src="item.pictureUrl"
              fit="cover"
            ></el-image>
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 轮播图 end-->
    <div class="container">
      <!-- 左侧轮播图和文档分类 -->
      <div class="findinformation-box fl">
        <!-- 免费文档推荐 start -->
        <div class="free-documentation">
          <!-- 免费文档推荐的文字 -->
          <div class="free-documentation-text">
            <h4 class="common fl">免费文档推荐</h4>
            <a href="#" class="fr" @click.prevent="goSearch">更多 &gt;</a>
            <strong></strong>
          </div>
          <!-- 免费文档区域 -->
          <ul class="free-documentation-picture">
            <li
              v-for="(item, index) in documentList.slice(0, 5)"
              :key="index"
              class="fl"
              @click="goInformationOne(item)"
            >
              <img :src="item.cover" alt />
              <!-- <div class="type">{{ item.type }}</div> -->
              <h5>{{ item.title }}</h5>
              <div class="document-introduce">
                <div class="integral fl" v-if="item.integral != 0">
                  积分:{{ item.integral }}
                </div>
                <div class="integral fl" v-else>免费</div>
                <div class="views fl">
                  <span>{{ item.views }}</span>
                  <span>浏览量</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 免费文档推荐 end -->
        <!-- 行业分类 start -->
        <!-- 分类第一行 -->
        <div class="industry-classfiy">
          <div class="industry-classfiy-text">
            <h4 class="common fl">行业分类</h4>
            <strong></strong>
          </div>
          <!-- 分类第一行 -->
          <div class="industryClassfiy">
            <a href="#" class="fr" @click.prevent="goSearch">更多 &gt;</a>
          </div>
          <div class="detailBox">
            <ul class="tatol">
              <li
                v-for="(item, index) in classifyList.slice(0, 3)"
                :class="{ totalActive: activeOne == index }"
                @click="showOne(index, item.code)"
                :key="index"
              >
                {{ item.cateName }}
              </li>
              <!-- 下面的内容 -->
            </ul>
            <ul class="freeDocumentation-picture">
              <div
                v-for="(item, index) in docListOne.slice(0, 5)"
                :key="index"
                class="freeDocumentation fl"
                @click="goInformationOne(item)"
              >
                <img :src="item.cover" alt />
                <!-- <div class="type">{{ item.type }}</div> -->
                <h5>{{ item.title }}</h5>
                <div class="document-introduce">
                  <div class="integral fl" v-if="item.integral != 0">
                    积分:{{ item.integral }}
                  </div>
                  <div class="integral fl" v-else>免费</div>
                  <div class="views fl">
                    <span>{{ item.views }}</span>
                    <span>浏览量</span>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
        <!-- 分类第二行 -->
        <div class="industryClassfiy">
          <a
            href="#"
            class="fr"
            style="line-height: 54px"
            @click.prevent="goSearch"
            >更多 &gt;</a
          >
        </div>
        <div class="detailBox">
          <ul class="tatol">
            <li
              v-for="(item, index) in classifyList.slice(3, 6)"
              :class="{ totalActive: activeTwo == index }"
              @click="showTwo(index, item.code)"
              :key="index"
            >
              {{ item.cateName }}
            </li>
            <!-- 下面的内容 -->
          </ul>
          <ul class="freeDocumentation-picture">
            <div
              v-for="(item, index) in docListTwo.slice(0, 5)"
              :key="index"
              class="freeDocumentation fl"
              @click="goInformationOne(item)"
            >
              <img :src="item.cover" alt />
              <!-- <div class="type">{{ item.type }}</div> -->
              <h5>{{ item.title }}</h5>
              <div class="document-introduce">
                <div class="integral fl" v-if="item.integral != 0">
                  积分:{{ item.integral }}
                </div>
                <div class="integral fl" v-else>免费</div>
                <div class="views fl">
                  <span>{{ item.views }}</span>
                  <span>浏览量</span>
                </div>
              </div>
            </div>
          </ul>
        </div>

        <!-- 分类第三行 -->
        <div class="industryClassfiy">
          <a
            href="#"
            class="fr"
            style="line-height: 52px"
            @click.prevent="goSearch"
            >更多 &gt;</a
          >
        </div>
        <div class="detailBox">
          <ul class="tatol" style="width: 350px">
            <li
              v-for="(item, index) in classifyList.slice(6, 10)"
              :class="{ totalActive: activeThree == index }"
              @click="showThree(index, item.code)"
              :key="index"
            >
              {{ item.cateName }}
            </li>
            <!-- 下面的内容 -->
          </ul>
          <ul class="freeDocumentation-picture">
            <div
              v-for="(item, index) in docListThree.slice(0, 5)"
              :key="index"
              class="freeDocumentation fl"
              @click="goInformationOne(item)"
            >
              <img :src="item.cover" alt />
              <!-- <div class="type">{{ item.type }}</div> -->
              <h5>{{ item.title }}</h5>
              <div class="document-introduce">
                <div class="integral fl" v-if="item.integral != 0">
                  积分:{{ item.integral }}
                </div>
                <div class="integral fl" v-else>免费</div>
                <div class="views fl">
                  <span>{{ item.views }}</span>
                  <span>浏览量</span>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <!-- 行业分类 end -->
        <!-- 推荐模块start -->
        <div class="recommend-mode">
          <h4 class="common fl">推荐模板</h4>
          <strong></strong>
        </div>
        <ul class="recommend">
          <li
            class="fl"
            v-for="(t, index) in templateList"
            :key="index"
            @click="goInformationTwo(t)"
          >
            <img :src="t.cover ? t.cover : image" />
            <span style="display: block; width: 80%; height: 20px">{{
              t.title
            }}</span>
          </li>
        </ul>
        <!-- 推荐模块end -->
      </div>
      <!-- 右侧上传文档和热搜关键词 -->
      <div class="upload-document fr">
        <!-- 上传积分的信息部分 -->
        <div class="upload-document-information">
          <img src="./uploads/findinformation file.png" alt class="fl" />
          <p class="fl">
            已有
            <span>超过100000</span>会员上传并分享了文档，你的文档在哪里？
          </p>
          <el-button class="upload-document-points" @click="goDocument"
            >上传文档获取积分</el-button
          >
        </div>
        <!-- 上传积分的信息部分 end -->
        <!-- 热搜关键词 start-->
        <div class="hot-search">
          <p class="hot-search-word fl">热搜关键词</p>
          <b style="width: 83px"></b>
        </div>
        <ul class="hot-keyword-box">
          <li
            class="fl"
            v-for="(hotKey, index) in keywordsList"
            :key="index"
            @click="goInformationSearch(hotKey)"
          >
            <img src="./uploads/findinformation vector.png" class="fl" />
            {{ hotKey ? hotKey : content }}
          </li>
        </ul>
        <!-- 热搜关键词 end-->
        <!-- 最新上传 start-->
        <div class="hot-search fl">
          <p class="hot-search-word fl">最新上传</p>
          <strong></strong>
        </div>
        <DotTemplate />
        <!-- 最新上传 end -->
        <!-- 热门文档 start -->
        <div class="hot-document fl">
          <div class="hot-search fl">
            <p class="hot-search-word fl">热门文档</p>
            <strong></strong>
          </div>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item
              :title="doc.title"
              :name="index"
              v-for="(doc, index) in wordList"
              :key="index"
            >
              <template #title>
                <div class="numberOrder fl">{{ index + 1 }}</div>
                <div class="el-collapse-item-title">{{ doc.title }}</div>
              </template>
              <div class="hot-word fl" @click="goInformationThree(doc)">
                <div class="hot-word-picture fl">
                  <span style="font-size: 18px" class="numberOrder fl">{{
                    index + 1
                  }}</span>
                  <img
                    src="../../assets/uploads/findinformation document.png"
                    alt
                  />
                  <h5 class="fr">{{ doc.title }}</h5>
                  <div class="size">
                    <h6>{{ doc.type }}</h6>
                    <p>大小:{{ doc.size }}MB</p>
                  </div>
                  <div class="integral">
                    <img :src="doc.cover" alt />
                    <p>积分:{{ doc.integral }}</p>
                  </div>
                  <div class="download">
                    <i class="iconfont icon-xiazai"></i>
                    <i>{{ doc.downloads }}</i>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 热门文档 end -->
        <!-- 用户贡献排行榜start -->
        <div class="user-contribution fl">
          <div class="hot-search fl">
            <p class="hot-search-word fl">用户贡献排行榜</p>
            <strong style="width: 111px"></strong>
            <p class="file-count fr">贡献文档数</p>
          </div>
          <ul class="user-contribution-msg">
            <li
              v-for="(u, index) in userList"
              :key="index"
              @click="goDetail(u)"
            >
              <div class="numberOrder fl">{{ index + 1 }}</div>
              <em>{{ u.userName }}</em>
              <p class="fr">{{ u.number }}</p>
            </li>
          </ul>
        </div>
        <!-- 用户贡献排行榜end -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  freeDocumentList,
  industryTypeList,
  hotSearchKeywords,
  hotDocument,
  userContributions,
  templateRecommend,
} from "@/api/data";
import { getDocumentPicture, topCates } from "@/api/common";

export default {
  name: "FindMaterials",
  data() {
    return {
      activeName: 0, // 默认展开第一个面板
      activeOne: 0, // 分类第一行
      activeTwo: 0, // 分类第二行
      activeThree: 0, // 分类第三行
      docListOne: [], //文档一
      docListTwo: [], //文档二
      docListThree: [], //文档三
      rotationList: [], // 轮播图列表
      documentList: [], // 免费文档推荐
      industryList: [], // 行业分类
      templateList: [], // 模版推荐
      keywordsList: [], //热搜关键词
      userList: [], // 用户贡献排行榜
      wordList: [], // 热门文档
      classifyList: [], // 行业分类切换
      searchWord: "", // 搜索关键词
      image:
        "https://zhongan-resource-test.oss-cn-beijing.aliyuncs.com/pic/PPT.png",
      content: "全部",
    };
  },

  mounted() {
    // 轮播图
    getDocumentPicture(3, 18).then((res) => {
      if (res.code == 200) {
        this.rotationList = res.data;
      }
    });
    // 行业分类切换
    topCates().then((res) => {
      if (res.code == 200) {
        this.classifyList = res.data;
      }
      const data1 = {
        count: 12,
        cateCode: 11,
      };
      const data2 = {
        cateCode: 14,
      };
      const data3 = {
        cateCode: 17,
      };
      // 热搜关键词
      hotSearchKeywords(data1).then((res) => {
        if (res.code == 200) {
          this.keywordsList = res.data;
        }
      });
      // 行业分类
      industryTypeList(data1).then((res) => {
        if (res.code == 200) {
          this.docListOne = res.data;
        }
      });
      industryTypeList(data2).then((res) => {
        if (res.code == 200) {
          this.docListTwo = res.data;
        }
      });
      industryTypeList(data3).then((res) => {
        if (res.code == 200) {
          this.docListThree = res.data;
        }
      });
      // 模版推荐
      templateRecommend().then((res) => {
        if (res.code == 200) {
          this.templateList = res.data;
        }
      });
    });
    // 免费文档推荐
    freeDocumentList().then((res) => {
      if (res.code == 200) {
        this.documentList = res.data;
      }
    });
    // 热门文档
    hotDocument().then((res) => {
      if (res.code == 200) {
        this.wordList = res.data;
      }
    });
    // 用户贡献排行榜
    userContributions().then((res) => {
      if (res.code == 200) {
        this.userList = res.data;
      }
    });
  },
  methods: {
    showOne(index, code) {
      this.activeOne = index;
      const data = {
        cateCode: code,
      };
      industryTypeList(data).then((res) => {
        if (res.code == 200) {
          this.docListOne = res.data;
          // console.log(this.docList);
        }
      });
    },
    goDetail(teacher) {
      this.$router.push({
        path:
          "/materialsDetail?id=" +
          teacher.teacherId +
          "&industryType=" +
          teacher.industryType +
          "&workUnit=" +
          teacher.workUnit,
      });
    },
    showTwo(index2, code) {
      this.activeTwo = index2;
      const data = {
        cateCode: code,
      };
      industryTypeList(data).then((res) => {
        if (res.code == 200) {
          this.docListTwo = res.data;
        }
      });
    },
    showThree(index3, code) {
      this.activeThree = index3;
      const data = {
        cateCode: code,
      };
      industryTypeList(data).then((res) => {
        if (res.code == 200) {
          this.docListThree = res.data;
        }
      });
    },
    goInformationOne(item) {
      this.$router.push({
        path:
          "/materialsDetail?id=" +
          item.id +
          "&industryType=" +
          item.industryType,
      });
    },
    goInformationTwo(t) {
      this.$router.push({
        path:
          "/materialsDetail?id=" + t.id + "&industryType=" + t.industryType,
      });
    },
    goInformationThree(doc) {
      this.$router.push({
        path:
          "/materialsDetail?id=" +
          doc.id +
          "&industryType=" +
          doc.industryType,
      });
    },

    goInformationSearch(hotKey) {
      this.$router.push({
        path: "/materialsSearch/" + hotKey,
      });
    },
    goSearch() {
      this.$router.push({
        path: "/materialsSearch",
      });
    },
    goDocument() {
      this.$router.push({
        path: "/user/uploaddata",
      });
    },
  },
};
</script>

<style scoped>
/* 公共样式 */
.common {
  font-size: 18px;
  color: #eb5139;
}
/* 版心 */
.container {
  display: flex;
  width: 1200px;
  height: 2200px;
  margin-bottom: 31px;
}
/* 左侧轮播图和文档分类 start */
.findinformation-box {
  width: 799px;
  height: 2000px;
}
/* 轮播图 */

.data-rotation img {
  width: 100%;
  height: 300px;
}
/* 轮播图上面的横条 */
/* element轮播图的小圆点 */
.data-rotation >>> .el-carousel__indicator--horizontal {
  padding: 30px 5px;
}
.data-rotation >>> .el-carousel__button {
  width: 52px;
  height: 6px;
  background: #fff;
}
/* 小圆点选中颜色 */
.data-rotation >>> .is-active .el-carousel__button {
  background-color: #eb5139;
}
/* elementUI提供的 el-carousel 的默认样式*/
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  /* line-height: 150px; */
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/* 免费文档推荐区域 start */
/* 文档 */
.findinformation-box .free-documentation {
  height: 280px;
  margin-top: 30px;
  overflow: hidden;
}
/* 免费文档推荐的文字 */
.free-documentation-text {
  position: relative;
  height: 25px;
  margin-bottom: 38px;
}
/* 更多 */
.free-documentation-text a {
  font-size: 18px;
  color: #676c71;
}
/* 橙色的下划线 */
.free-documentation-text strong {
  position: absolute;
  top: 30px;
  left: 30px;
  width: 52px;
  height: 4px;
  background: #eb5139;
}
/* 免费文档区域 */
.free-documentation-picture {
  position: relative;
}
.free-documentation-picture .type {
  position: absolute;
  top: 70px;
  left: -8px;
  width: 155px;
  height: 59px;
  background: rgba(255, 255, 255, 0.63);
  box-shadow: inset 0px 4px 10px 0px #ffd6d2;
  border-radius: 9px 9px 9px 9px;
  filter: blur(undefinedpx);
  font-size: 36px;
  text-align: center;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
/* 每一块文档 */
.free-documentation-picture li {
  position: relative;
  margin: 0 10px;
  width: 140px;
  height: 200px;
  cursor: pointer;
}
.free-documentation-picture li:nth-child(5) {
  margin-right: 0px;
}
/* 文档背景图 */
.free-documentation-picture li img {
  width: 140px;
  height: 165px;
}
/* 文档背景图下面的文字 */
.free-documentation-picture li h5 {
  margin-left: 10px;
  width: 120px;
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.free-documentation-picture li .document-introduce {
  width: 100%;
  margin-left: 10px;
}
.free-documentation-picture li .document-introduce .integral {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ff7d69;
}

.free-documentation-picture li .document-introduce .views {
  font-size: 12px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #9a9999;
}
/*  免费文档推荐区域end */

/* 行业分类区域 start */
.industry-classfiy {
  height: auto;
  margin-top: 20px;
  overflow: hidden;
}
/* 行业分类文字 */
.industry-classfiy-text {
  position: relative;
  height: 25px;
  margin-bottom: 32px;
}
/* 行业分类文字下面的横条 */
.industry-classfiy-text strong {
  position: absolute;
  top: 30px;
  left: 10px;
  width: 52px;
  height: 4px;
  background: #eb5139;
}

/* 分类区域 */
/* 行业分类切换 */
/* 更多 */
.industryClassfiy a {
  display: inline-block;
  font-size: 18px;
  color: #676c71;
}
.freeDocumentation-picture {
  position: relative;
  margin-top: 20px;
  width: 794px;
  height: 243px;
}
/* 类型定位 */
.freeDocumentation-picture .type {
  position: absolute;
  top: 70px;
  left: -8px;
  width: 155px;
  height: 59px;
  background: rgba(255, 255, 255, 0.63);
  box-shadow: inset 0px 4px 10px 0px #ffd6d2;
  border-radius: 9px 9px 9px 9px;
  filter: blur(undefinedpx);
  font-size: 36px;
  text-align: center;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
/* 每一块文档 */
.freeDocumentation-picture .freeDocumentation {
  position: relative;
  margin: 0 10px;
  width: 140px;
  height: 200px;
  cursor: pointer;
}
.freeDocumentation-picture .freeDocumentation:nth-child(1) {
  margin-left: 0px;
}

.freeDocumentation-picture .freeDocumentation:nth-child(5) {
  margin-right: 0px;
}

.freeDocumentation-picture .freeDocumentation img {
  width: 140px;
  height: 165px;
}
/* 文档背景图下面的文字 */
.freeDocumentation-picture .freeDocumentation h5 {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 积分整体 */
.freeDocumentation-picture .freeDocumentation .document-introduce {
  margin-left: 10px;
  width: 100%;
}
.freeDocumentation-picture .freeDocumentation .document-introduce .integral {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ff7d69;
}
.freeDocumentation-picture .freeDocumentation .document-introduce .views {
  font-size: 12px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #9a9999;
}

.detailBox {
  margin-top: 15px;
  width: 810px;
  height: 280px;
}
.tatol {
  display: flex;
  margin-left: 0px;
  width: 255px;
  cursor: pointer;
}
.tatol > li {
  width: 65px;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  text-align: center;
}
.totalActive {
  color: #fff;
  background: #eb5139;
  border-radius: 4px;
}

/* 行业分类区域end */

/* 推荐模版 start */
.recommend-mode {
  position: relative;
  height: 25px;
  margin-top: 38px;
}
/* 推荐模版文字下面的横条 */
.recommend-mode strong {
  position: absolute;
  top: 30px;
  left: 10px;
  width: 52px;
  height: 4px;
  background: #eb5139;
}
/* 图片区域 */
.recommend {
  margin-top: 34px;
  height: auto;
}
.recommend li {
  display: flex;
  flex-direction: column;
  width: 159px;
  height: 160px;
  margin-bottom: 70px;
  text-align: center;
  cursor: pointer;
}
.recommend li img {
  height: 100%;
}
.recommend li p {
  text-align: center;
  color: #000;
  font-size: 14px;
}
/* 推荐模版 end */
/* 左侧轮播图和文档分类 end */

/* 右侧上传文档和热搜关键词start */
.upload-document {
  width: 351px;
  height: auto;
  overflow: hidden;
  margin-top: 30px;
  margin-left: 20px;
  background-color: #fff;
}
/* 上传积分的信息部分start */
.upload-document-information {
  margin-bottom: 5px;
  border-bottom: 2px solid #f5f7fa;
}
/* 上传文档积分的图片 */
.upload-document-information img {
  width: 143px;
  height: 109px;
  padding: 20px 25px;
}
/* 上传文档积分的文字 */
.upload-document-information p {
  width: 196px;
  height: 40px;
  font-size: 14px;
  margin-top: 55px;
  color: #333;
  margin-left: -50px;
}
/* 上传文档积分的变色文字 */
.upload-document-information p span {
  color: #ff2222;
}
/* 上传文档积分的按钮 */
.upload-document-points {
  margin-left: -85px;
  margin-bottom: 51px;
  margin-top: 76px;
  width: 137px;
  height: 49px;
  color: #fff;
  border-radius: 8px;
  border: 0;
  background-color: #ff2222;
}
/* 上传积分的信息部分end */

/* 热搜关键词 start */
.hot-search {
  position: relative;
  margin-left: 0px;
  padding: 15px;
  width: 120px;
  height: 22px;
}
.hot-search-word {
  position: absolute;
  top: 15px;
  left: 16px;
  color: #000;
  font-size: 16px;
  font-weight: 600;
}
/* 热搜关键词文字下面的横条 */
.hot-search b {
  margin-top: 15px;
  display: inline-block;
  width: 65px;
  height: 9px;
  background: #eb5139;
}
.hot-search strong {
  margin-top: 15px;
  display: inline-block;
  width: 65px;
  height: 9px;
  background: #eb5139;
}
/* 热度框 */
.hot-keyword-box {
  padding: 0 20px;
  margin-top: 10px;
  width: 332px;
  height: 200px;
  border-bottom: 2px solid #f5f7fa;
}
/* 每一个热搜框 */
.hot-keyword-box li {
  margin: 5px 10px;
  padding: 0 5px;
  box-sizing: border-box;
  width: 80px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #000;
  border-radius: 4px;
  border: 1px solid #676c71;
}
/* 热搜框里的小火苗 */
.hot-keyword-box li img {
  width: 15px;
  height: 22px;
  vertical-align: top;
  margin-right: 5px;
}
/* 热搜框里的文字 */

/* 热搜关键词 end */

/* 最新上传 start*/
/* 最新上传 end*/

/* 热门文档start */
/* 热门文档 */
.hot-document {
  width: 350px;
  height: auto;
  border-bottom: 2px solid #f5f7fa;
}
/* 排序的数字 */
.hot-document .numberOrder {
  margin-right: 20px;
  color: #999aa9;
}
.hot-document >>> .el-collapse-item:nth-child(1) .numberOrder {
  color: #e88569;
}
.hot-document >>> .el-collapse-item:nth-child(2) .numberOrder {
  color: #efb543;
}
.hot-document >>> .el-collapse-item:nth-child(3) .numberOrder {
  color: #b57f30;
}
/* 整体 */
.hot-document >>> .el-collapse {
  margin-top: 50px;
  margin-left: 20px;
  width: 320px;
  border: 0;
  cursor: pointer;
}
.el-collapse-item-title {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 排序的数字 */
.hot-document >>> .el-collapse-item {
  color: #999aa9;
}
.hot-document >>> .el-collapse-item__header {
  border: 0;
  width: 320px;
}
.hot-document >>> .el-collapse-item__wrap {
  border: 0;
}
/* 文档图片 */
.hot-document .hot-word {
  height: 215px;
}
.hot-word-picture {
  position: relative;
  width: 267px;
  height: 215px;
  margin: 0 30px;
}
/* 数字1的定位 */
.hot-word-picture span {
  position: absolute;
  top: 7px;
  left: 12px;
}
/* 文档背景图 */
.hot-word-picture img {
  width: 143px;
  height: 189px;
}
.hot-word-picture h5 {
  /* margin-right: 30px; */
  margin-top: 43px;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}
/* 需要定位的 容量大小 */
.hot-word-picture .size {
  position: absolute;
  left: 17px;
  top: 60px;
  font-weight: 600;
}
/* 第一行文字 */
.hot-word-picture .size h6 {
  font-size: 14px;
  color: #000;
}
/* 第二行文字 */
.hot-word-picture .size p {
  color: #676c71;
  font-size: 12px;
}
/* 需要定位的 积分 */
.hot-word-picture .integral {
  position: absolute;
  left: 110px;
  top: 110px;
  font-weight: 600;
}
/* 文档图标 */
.hot-word-picture .integral img {
  width: 30px;
  height: 30px;
}
.hot-word-picture .integral p {
  color: #ff7d69;
  font-size: 12px;
  margin-left: -25px;
}
/* 需要定位的 下载量 */
.hot-word-picture .download {
  position: absolute;
  bottom: 40px;
  right: -50px;
  width: 115px;
  height: 20px;
  color: #a4a5b2;
  font-size: 14px;
}
/* 字体图标 */
.hot-word-picture .download i {
  margin-right: 5px;
}

/* 热门文档 end */

/* 用户贡献排行榜 start*/
.user-contribution {
  height: auto;
}
.user-contribution .hot-search {
  width: 330px;
}
.user-contribution .file-count {
  margin-top: 4px;
  font-size: 14px;
  color: #676c71;
}
/* 用户贡献信息列表 */

.user-contribution-msg {
  height: auto;
  padding: 0 25px;
}
.user-contribution-msg li {
  margin-bottom: 15px;
  cursor: pointer;
}
/* 排序的数字 */
.user-contribution-msg .numberOrder {
  margin-right: 20px;
  color: #999aa9;
}
.user-contribution-msg li:nth-child(1) .numberOrder {
  color: #e88569;
}
.user-contribution-msg li:nth-child(2) .numberOrder {
  color: #efb543;
}
.user-contribution-msg li:nth-child(3) .numberOrder {
  color: #b57f30;
}
.user-contribution-msg em {
  color: #333;
  font-size: 14px;
  font-weight: 600;
}
/* 数量 */
.user-contribution-msg p {
  width: 50px;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #a4a5b2;
}
/* 用户贡献排行榜 end*/
/* 右侧上传文档和热搜关键词end */
</style>
